export default __webpack_public_path__ + "static/media/36_mobile.a0111d2a.jpg";